import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Tabs,
  Tab,
  Button,
} from "@mui/material";
import { useState } from "react";
import "../home/home.scss";
import * as XLSX from "xlsx";

const tabsData = [
  "OFAC",
  "UK sanctions",
  "NON SDN",
];

function DelistedEntity() {
    // For Files Comparision
    const [sourceFile, setSourceFile] = useState("");
    const [historyFile, setHistoryFile] = useState("");
    const [compareResult, setCompareResult] = useState([]);
    const [showCompareTable, setShowCompareTable] = useState(false);
    const [showBankFormat, setShowBankFormat] = useState(false);
    const [submittedData, setSubmittedData] = useState(
        tabsData.reduce((acc, tab) => {
        acc[tab] = [];
        return acc;
        }, {})
    );
    

    // For comparision
    const handleCompare = () => {
        if (!sourceFile || !historyFile) return;
        // For demo: always show at least one missing row
        const sourceRows = previewTableData;
        const historyRows = previewTableData.slice(1); // Remove first row for demo
        // Find missing rows by SDN_NAME (as example)
        const missing = sourceRows.filter(
            s => !historyRows.some(h => h.SDN_NAME === s.SDN_NAME)
        );
        setCompareResult(missing);
        setShowCompareTable(true);
        setShowBankFormat(false);
    };

    const handleGenerateBankFormat = () => {
        setShowBankFormat(true);
    };

    const handleDownloadExcel = () => {
        const data = showBankFormat ? previewTableData : compareResult;
        if (!data || data.length === 0) return;
        const headers = Object.keys(data[0]);
        const rows = data.map(row => headers.map(h => row[h]));
        const sheetData = [headers, ...rows];
        const ws = XLSX.utils.aoa_to_sheet(sheetData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Compare Data");
        XLSX.writeFile(wb, "compare_result.xlsx");
    };

    // Dummy file data for OFAC, UK sanctions, and NON SDN for demo file selection
    const demoFiles = {
        OFAC: [
            { id: 'ofac-2024-03-15-120000', name: 'ofac-2024-03-15-120000', date: '2024-03-15', time: '12:00:00' },
            { id: 'ofac-2024-03-14-150000', name: 'ofac-2024-03-14-150000', date: '2024-03-14', time: '15:00:00' },
            { id: 'ofac-2024-03-13-180000', name: 'ofac-2024-03-13-180000', date: '2024-03-13', time: '18:00:00' },
        ],
        'UK sanctions': [
            { id: 'uk-sanctions-2024-03-15-140000', name: 'uk-sanctions-2024-03-15-140000', date: '2024-03-15', time: '14:00:00' },
            { id: 'uk-sanctions-2024-03-14-170000', name: 'uk-sanctions-2024-03-14-170000', date: '2024-03-14', time: '17:00:00' },
            { id: 'uk-sanctions-2024-03-13-200000', name: 'uk-sanctions-2024-03-13-200000', date: '2024-03-13', time: '20:00:00' },
        ],
        'NON SDN': [
            { id: 'non-sdn-2024-03-15-150000', name: 'non-sdn-2024-03-15-150000', date: '2024-03-15', time: '15:00:00' },
            { id: 'non-sdn-2024-03-14-180000', name: 'non-sdn-2024-03-14-180000', date: '2024-03-14', time: '18:00:00' },
            { id: 'non-sdn-2024-03-13-210000', name: 'non-sdn-2024-03-13-210000', date: '2024-03-13', time: '21:00:00' },
        ],
    };

    const [selectedTab, setSelectedTab] = useState(0);
    // Change submittedData to store files per tab
    const allFiles = submittedData[tabsData[selectedTab]] || [];
    const isDemoTab = ["OFAC", "UK sanctions", "NON SDN"].includes(tabsData[selectedTab]);
    const fileOptions = isDemoTab ? demoFiles[tabsData[selectedTab]] : allFiles;    

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
        setShowBankFormat(false);
        setShowCompareTable(false);
        setSourceFile("");
        setHistoryFile("");
    };

    const previewTableData = [
        {
        id: 0,
        ENT_NUM: 36,
        SDN_NAME: "AEROCARIBBEAN AIRLINES",
        SDN_TYPE: "-0-",
        Program: "CUBA",
        Title: "-0-",
        Call_Sign: "-0-",
        Vessel_Type: "-0-",
        Tonnage: "-0-",
        GRT: "-0-",
        Vessel_Flag: "-0-",
        Vessel_Owner: "-0-",
        Remarks: "-0-"
        },
        {
        id: 1,
        ENT_NUM: 173,
        SDN_NAME: "ANGLO-CARIBBEAN CO., LTD.",
        SDN_TYPE: "-0-",
        Program: "CUBA",
        Title: "-0-",
        Call_Sign: "-0-",
        Vessel_Type: "-0-",
        Tonnage: "-0-",
        GRT: "-0-",
        Vessel_Flag: "-0-",
        Vessel_Owner: "-0-",
        Remarks: "-0-"
        },
        {
        id: 2,
        ENT_NUM: 306,
        SDN_NAME: "BANCO NACIONAL DE CUBA",
        SDN_TYPE: "-0-",
        Program: "CUBA",
        Title: "-0-",
        Call_Sign: "-0-",
        Vessel_Type: "-0-",
        Tonnage: "-0-",
        GRT: "-0-",
        Vessel_Flag: "-0-",
        Vessel_Owner: "-0-",
        Remarks: "a.k.a. 'BNC'."
        },
        {
        id: 3,
        ENT_NUM: 424,
        SDN_NAME: "BOUTIQUE LA MAISON",
        SDN_TYPE: "-0-",
        Program: "CUBA",
        Title: "-0-",
        Call_Sign: "-0-",
        Vessel_Type: "-0-",
        Tonnage: "-0-",
        GRT: "-0-",
        Vessel_Flag: "-0-",
        Vessel_Owner: "-0-",
        Remarks: "-0-"
        },
        {
        id: 4,
        ENT_NUM: 475,
        SDN_NAME: "CASA DE CUBA",
        SDN_TYPE: "-0-",
        Program: "CUBA",
        Title: "-0-",
        Call_Sign: "-0-",
        Vessel_Type: "-0-",
        Tonnage: "-0-",
        GRT: "-0-",
        Vessel_Flag: "-0-",
        Vessel_Owner: "-0-",
        Remarks: "-0-"
        },
        {
        id: 5,
        ENT_NUM: 480,
        SDN_NAME: "CECOEX, S.A.",
        SDN_TYPE: "-0-",
        Program: "CUBA",
        Title: "-0-",
        Call_Sign: "-0-",
        Vessel_Type: "-0-",
        Tonnage: "-0-",
        GRT: "-0-",
        Vessel_Flag: "-0-",
        Vessel_Owner: "-0-",
        Remarks: "-0-"
        },
        {
        id: 6,
        ENT_NUM: 535,
        SDN_NAME: "CIMEX",
        SDN_TYPE: "-0-",
        Program: "CUBA",
        Title: "-0-",
        Call_Sign: "-0-",
        Vessel_Type: "-0-",
        Tonnage: "-0-",
        GRT: "-0-",
        Vessel_Flag: "-0-",
        Vessel_Owner: "-0-",
        Remarks: "-0-"
        },
        {
        id: 7,
        ENT_NUM: 536,
        SDN_NAME: "CIMEX IBERICA",
        SDN_TYPE: "-0-",
        Program: "CUBA",
        Title: "-0-",
        Call_Sign: "-0-",
        Vessel_Type: "-0-",
        Tonnage: "-0-",
        GRT: "-0-",
        Vessel_Flag: "-0-",
        Vessel_Owner: "-0-",
        Remarks: "-0-"
        },
        {
        id: 8,
        ENT_NUM: 537,
        SDN_NAME: "CIMEX, S.A.",
        SDN_TYPE: "-0-",
        Program: "CUBA",
        Title: "-0-",
        Call_Sign: "-0-",
        Vessel_Type: "-0-",
        Tonnage: "-0-",
        GRT: "-0-",
        Vessel_Flag: "-0-",
        Vessel_Owner: "-0-",
        Remarks: "-0-"
        },
        {
        id: 9,
        ENT_NUM: 540,
        SDN_NAME: "COMERCIAL IBEROAMERICANA, S.A.",
        SDN_TYPE: "-0-",
        Program: "CUBA",
        Title: "-0-",
        Call_Sign: "-0-",
        Vessel_Type: "-0-",
        Tonnage: "-0-",
        GRT: "-0-",
        Vessel_Flag: "-0-",
        Vessel_Owner: "-0-",
        Remarks: "-0-"
        }
    ];
    const modalPreviewTableData = [
        {
        id: 0,
        col1: "BANKSESSXXXX",
        col2: "I103BANKNO2XXXXN",
        col3: "SEPA, MNO987123654",
        col4: "",
        col20: "REF987123654",
        col23B: "CRED",
        col32A: "240303SEK3000",
        col50A: "/9871236540 OLIVER ERICSON",
        col57A: "BANKNO2X",
        col59: "/5566778899 HENRY JOHNSTON",
        col70: "HOUSE RENT",
        col71A: "SHA",
        col72: "/INS/SAME DAY PROCESSING",
        },
        {
        id: 1,
        col1: "BANKFIHHXXXX",
        col2: "I103BANKDKKKXXXXN",
        col3: "SEPA, PQR456789123",
        col4: "",
        col20: "REF456789123",
        col23B: "CRED",
        col32A: "240303SEK5000",
        col50A: "/4567891230 EMMA WILSON",
        col57A: "BANKDKKKX",
        col59: "/1122334455 JAMES BROWN",
        col70: "CAR LOAN",
        col71A: "SHA",
        col72: "/INS/SAME DAY PROCESSING",
        },
        {
        id: 2,
        col1: "BANKPTPLXXXX",
        col2: "I103BANKGRXXXXXXN",
        col3: "SEPA, STU654321987",
        col4: "",
        col20: "REF654321987",
        col23B: "CRED",
        col32A: "240303SEK7000",
        col50A: "/6543219870 LUCAS MARTIN",
        col57A: "BANKGRXXX",
        col59: "/9988776655 SARAH DAVIS",
        col70: "HOME RENOVATION",
        col71A: "SHA",
        col72: "/INS/SAME DAY PROCESSING",
        },
        {
        id: 3,
        col1: "BANKESPBXXXX",
        col2: "I103BANKITRRXXXXN",
        col3: "SEPA, VWX321654987",
        col4: "",
        col20: "REF321654987",
        col23B: "CRED",
        col32A: "240303SEK4000",
        col50A: "/3216549870 SOPHIA LEE",
        col57A: "BANKITRRX",
        col59: "/4455667788 MICHAEL WHITE",
        col70: "EDUCATION",
        col71A: "SHA",
        col72: "/INS/SAME DAY PROCESSING",
        },
        {
        id: 4,
        col1: "BANKDEFFXXXX",
        col2: "I103BANKFRXXXXXXN",
        col3: "SEPA, YZA987654321",
        col4: "",
        col20: "REF987654321",
        col23B: "CRED",
        col32A: "240303SEK6000",
        col50A: "/9876543210 THOMAS CLARK",
        col57A: "BANKFRXXX",
        col59: "/6677889900 LUCY ADAMS",
        col70: "BUSINESS EXPENSE",
        col71A: "SHA",
        col72: "/INS/SAME DAY PROCESSING",
        },
    ];

  return (
    <div className="home-page">
        <div className="page-container">
            {/* Horizontal Scrolling Tabs - replaced Box with Bootstrap row */}
            <div className="row border-bottom mb-3" style={{ borderColor: '#dee2e6' }}>
                <div className="col-12">
                    <Tabs
                    value={selectedTab}
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="reference data tabs"
                    sx={{
                        '& .MuiTabs-indicator': { display: 'none' },
                        '& .MuiTab-root': {
                        color: 'rgba(0, 0, 0, 0.6)',
                        backgroundColor: '#ccc',
                        padding: '15px',
                        borderRadius: '4px 4px 0 0',
                        marginRight: '5px',
                        '&.Mui-selected': {
                            backgroundColor: 'var(--theme-color)',
                            color: 'white',
                            borderRadius: '4px 4px 0 0',
                        }
                        }
                    }}
                    >
                    {tabsData.map((tab, index) => (
                        <Tab key={index} label={tab} />
                    ))}
                    </Tabs>
                </div>
            </div>

            <div className="row mb-4 align-items-end">
                <div className="col-md-6">
                    <FormControl fullWidth size="small">
                    <InputLabel>Source File</InputLabel>
                    <Select
                        value={sourceFile}
                        label="Source File"
                        onChange={e => setSourceFile(e.target.value)}
                    >
                        {fileOptions.map(f => (
                            <MenuItem key={f.id} value={f.id}>{f.name || f.file?.name || f.fileName}</MenuItem>
                        ))}
                    </Select>
                    </FormControl>
                </div>
                <div className="col-md-6">
                    <FormControl fullWidth size="small">
                    <InputLabel>History File</InputLabel>
                    <Select
                        value={historyFile}
                        label="History File"
                        onChange={e => setHistoryFile(e.target.value)}
                    >
                        {fileOptions.map(f => (
                            <MenuItem key={f.id} value={f.id}>{f.name || f.file?.name || f.fileName}</MenuItem>
                        ))}
                    </Select>
                    </FormControl>
                </div>
                <div className="text-center mt-3">
                    <Button
                    variant="contained"
                    color="primary"
                    className="btn createButton"
                    onClick={handleCompare}
                    >
                    Compare
                    </Button>
                </div>
            </div>
            {showCompareTable && !showBankFormat && (
                <div className="card p-3 mb-3">
                    <h6>Missing Data</h6>
                    <div className="table-responsive">
                        <table className="table table-bordered table-striped">
                        <thead className="table-dark">
                            <tr>
                            <th>#</th>
                            <th>ENT_NUM</th>
                            <th>SDN_NAME</th>
                            <th>SDN_TYPE</th>
                            <th>Program</th>
                            <th>Title</th>
                            <th>Call_Sign</th>
                            <th>Vessel_Type</th>
                            <th>Tonnage</th>
                            <th>GRT</th>
                            <th>Vessel_Flag</th>
                            <th>Vessel_Owner</th>
                            <th>Remarks</th>
                            </tr>
                        </thead>
                        <tbody>
                            {compareResult.map((row, idx) => (
                            <tr key={row.id}>
                                <td>{idx + 1}</td>
                                <td>{row.ENT_NUM}</td>
                                <td>{row.SDN_NAME}</td>
                                <td>{row.SDN_TYPE}</td>
                                <td>{row.Program}</td>
                                <td>{row.Title}</td>
                                <td>{row.Call_Sign}</td>
                                <td>{row.Vessel_Type}</td>
                                <td>{row.Tonnage}</td>
                                <td>{row.GRT}</td>
                                <td>{row.Vessel_Flag}</td>
                                <td>{row.Vessel_Owner}</td>
                                <td>{row.Remarks}</td>
                            </tr>
                            ))}
                        </tbody>
                        </table>
                    </div>
                    <div className="d-flex justify-content-center mt-2">
                    <Button variant="contained" color="primary" className="btn createButton"  onClick={handleGenerateBankFormat} disabled={compareResult.length === 0}>Generate</Button>
                    </div>
                </div>
            )}
            {showBankFormat && (
                <div className="card p-3 mb-3">
                    <div className="d-flex justify-content-start mt-2 mb-4">
                        <Button variant="contained" color="primary" className="btn createButton" onClick={handleDownloadExcel}>Download</Button>
                    </div>
                    <div className="table-responsive">
                        <table className="table table-bordered table-striped">
                        <thead className="table-dark">
                            <tr>
                            <th>#</th>
                            <th>1:</th>
                            <th>2:</th>
                            <th>3:</th>
                            <th>4:</th>
                            <th>:20:</th>
                            <th>:23B:</th>
                            <th>:32A:</th>
                            <th>:50A:</th>
                            <th>:57A:</th>
                            <th>:59:</th>
                            <th>:70:</th>
                            <th>:71A:</th>
                            <th>:72:</th>
                            </tr>
                        </thead>
                        <tbody>
                            {modalPreviewTableData.map((row, idx) => (
                            <tr key={row.id}>
                                <td>{idx + 1}</td>
                                <td>{row.col1}</td>
                                <td>{row.col2}</td>
                                <td>{row.col3}</td>
                                <td>{row.col4}</td>
                                <td>{row.col20}</td>
                                <td>{row.col23B}</td>
                                <td>{row.col32A}</td>
                                <td>{row.col50A}</td>
                                <td>{row.col57A}</td>
                                <td>{row.col59}</td>
                                <td>{row.col70}</td>
                                <td>{row.col71A}</td>
                                <td>{row.col72}</td>
                            </tr>
                            ))}
                        </tbody>
                        </table>
                    </div>
                    
                </div>
            )}
        </div>
    </div>
  );
}

export default DelistedEntity;
